import axios from "@/api/AuthAPI/auth-request-api";
import { auth } from "@/config/host.config";
import { AxiosResponse } from "axios";
import { IRestaurant } from "@/@types/admin/restourant/restourant";

export const RestaurantAPI = {
  getAll(
    match: Record<string, unknown> = {}
  ): Promise<AxiosResponse<IRestaurant[]>> {
    const params: Record<string, unknown> = {};
    Object.keys(match).forEach((key) => {
      const value = match[key];
      if (typeof value === "object" && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params[`match[${key}][${subKey}]`] = (
            value as Record<string, unknown>
          )[subKey];
        });
      } else {
        params[`match[${key}]`] = value;
      }
    });
    return axios.get(auth.restaurant, { params });
  },

  getById(id: string): Promise<AxiosResponse<IRestaurant>> {
    return axios.get(`${auth.restaurant}/${id}`);
  },

  add(body: Partial<IRestaurant>): Promise<AxiosResponse<IRestaurant>> {
    return axios.post(auth.restaurant, body);
  },

  updateById(
    id: string,
    body: Partial<IRestaurant>
  ): Promise<AxiosResponse<IRestaurant>> {
    return axios.put(`${auth.restaurant}/${id}`, body);
  },

  updatePlan(
    id: string,
    body: {
      tables: IRestaurant["tables"];
      walls: IRestaurant["walls"];
      planWidth: number;
      planHeight: number;
      planBackground: string;
    }
  ): Promise<AxiosResponse<IRestaurant>> {
    return axios.put(`${auth.restaurant_plan}/${id}/plan`, body);
  },

  deleteById(id: string): Promise<AxiosResponse<IRestaurant>> {
    return axios.delete(`${auth.restaurant}/${id}`);
  },

  forceDeleteById(id: string): Promise<AxiosResponse<void>> {
    return axios.delete(`${auth.restaurant_force}/${id}`);
  },

  restoreById(id: string): Promise<AxiosResponse<void>> {
    return axios.put(`${auth.restaurant_recycler}/${id}`);
  },
};
